import o, { css as p } from "styled-components";
import { Modal as n } from "./atoms-v226.js";
import { breakpoints as d } from "./atoms-v2125.js";
import { Button as a } from "./atoms-v26.js";
import { TextInput as c } from "./atoms-v244.js";
import { PaymentButton as s } from "./atoms-v21029.js";
const m = o.div`
  display: flex;
  flex-direction: column;
`;
o(n.Content)`
  flex-direction: column;
  padding: 0;
`;
o(n.Wrapper)`
  height: auto;
  width: 520px;
`;
const v = o.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 24px;
`, y = o.div`
  background-color: ${({ $colorTheme: r, theme: i }) => i == null ? void 0 : i.get(`tokens.surface.${r}.layer01`)};
  height: 8px;
  width: 100%;
`, $ = o.div`
  display: flex;
  gap: 8px;
  margin-top: 10px;
`, b = o(a)`
  height: 44px;
  width: 44px;

  @media ${d.medium} {
    height: 56px;
    width: 56px;
  }
`, k = o(c)`
  flex: 1;
`, C = o(s)`
  ${({ $colorTheme: r, $isSelected: i }) => i && p`
      border-color: ${({ theme: t }) => t == null ? void 0 : t.get(`tokens.border.${r}.main`)};

      &:hover {
        border-color: ${({ theme: t }) => t == null ? void 0 : t.get(`tokens.border.${r}.main`)};
      }
    `}
`;
export {
  $ as CVVContainer,
  k as CvvInput,
  y as Divider,
  v as PaymentOptionsSection,
  b as SaveButton,
  C as SavedCardButton,
  m as Wrapper
};
